<template>
    <div class="flex flex-col h-full items-center justify-center lg:px-0 lg:py-0 px-4 py-10">
        <h4 class="text-center m-y-md md:w-1/2 w-full">{{ $t('auth.connect_to_an_application') }}</h4>

        <p class="md:w-1/2 pb-6 text-center w-full">{{ $t('auth.connect_to_an_application_line') }}</p>

        <div class="md:w-1/2 w-full">
            <div class="bg-transparent border-gray-400 card">
                <div class="card-body">
                    <template v-for="(organizationApplication, index) in user.organization_applications">
                        <button @click="connectToApplication(index)" class="border-b last:border-b-0 border-gray-400 flex focus:outline-none group items-center py-3 w-full">
                            <div v-if="organizationApplication.application.slug === 'crm'" class="bg-purple-500 flex h-8 items-center justify-center mr-4 p-2 rounded-full w-8">
                                <svg class="block fill-current h-8 text-white w-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path d="M8 24l3-9h-9l14-15-3 9h9l-14 15z"></path>
                                </svg>
                            </div>
                            <div v-else-if="organizationApplication.application.slug === 'tasks'" class="bg-red-500 flex h-8 items-center justify-center mr-4 p-2 rounded-full w-8">
                                <svg class="block fill-current h-8 text-white w-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path d="M4.967 15c-2.743 0-4.967-2.238-4.967-5 0-2.761 2.224-5 4.967-5h5.033v10h-5.033zm7.04 7.475c-.52-.424-.902-.994-1.095-1.637l-1.151-3.827h-5.125l1.905 5.883c.214.659.828 1.106 1.521 1.106h3.439c.358 0 .677-.225.797-.562.12-.337.015-.713-.263-.939l-.028-.024zm-.007-17.475v10c3.164.509 7.161 1.992 12 5v-20c-4.964 3.085-8.876 4.502-12 5z"></path>
                                </svg>
                            </div>
                            <div v-else-if="organizationApplication.application.slug === 'budgets'" class="bg-blue-500 flex h-8 items-center justify-center mr-4 p-2 rounded-full w-8">
                                <svg class="block fill-current h-8 text-white w-8" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path d="M5 19h-4v-4h4v4zm6 0h-4v-8h4v8zm6 0h-4v-13h4v13zm6 0h-4v-19h4v19zm1 2h-24v2h24v-2z"></path>
                                </svg>
                            </div>
                            <div class="flex flex-col flex-grow text-left">
                                <div class="font-light text-base tracking-wide">{{ organizationApplication.application.name }}</div>
                            </div>
                            <div class="animated-chevron-transition pl-3 group-hover:pl-0 group-hover:pr-3">
                                <svg class="fill-current h-6 text-gray-600 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z"/></svg>
                            </div>
                        </button>
                    </template>
                </div>
            </div>
        </div>

        <div class="block divider md:w-1/2 w-full">
            <div class="divider-content">{{ $t('globals.or').toUpperCase() }}</div>
        </div>

        <div class="md:w-1/2 w-full">
            <p class="text-center">{{ $t('auth.go_to_dashboard_line') }}</p>
            <div class="text-center pt-3">
                <a class="btn btn-block btn-outline-primary" href="/dashboard">{{ $t('auth.go_to_dashboard') }}</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        user: Object,
    },

    data() {
        return {
            form: new Form({
                organization_application_user_id: '',
                session_data: null,
            }),
            applicationInstance: null,
            applicationForm: new Form({
                user_id: '',
                token: '',
            }),
        };
    },

    computed: {
        sessionData() {
            return window.Globals.sessionData ?? [];
        },
    },

    methods: {
        connectToApplication(index) {
            const organizationApplication = this.user.organization_applications[index];
            this.form.organization_application_user_id = organizationApplication.pivot.id;
            this.form.session_data = this.sessionData;

            Globals.post('/api/v1/authentication-token', this.form)
                .then(response => {
                    this.applicationInstance = axios.create({ baseURL: organizationApplication.application.url, withCredentials: true });
                    this.applicationForm.user_id = response.user_access.user_id;
                    this.applicationForm.token = response.token;
                })
                .then(() => this.applicationInstance.post('/login', this.applicationForm))
                .then(() => window.location.href = organizationApplication.application.url)
                .catch(error => {
                    const errors = this.form.errors.any() ? this.form.errors.flatten() : this.applicationForm.errors.flatten();
                    const message = errors.length > 0 ? errors[0] : this.$t('globals.unexpected_error');
                    window.toastr.clear();
                    window.toastr.error(message);
                })
                .finally(() => {
                    this.resetForms();
                    this.applicationInstance = null;
                });
        },

        resetForms() {
            this.form = new Form({
                organization_application_user_id: '',
                session_data: null,
            });
            this.applicationForm = new Form({
                user_id: '',
                token: '',
            });
        },
    },
};
</script>
